module.exports = __webpack_public_path__ + "static/fonts/kendoui.29409af.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/images/kendoui.ttf?v=1.1
// module id = 1652
// module chunks = 28